import { Col, Row, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import TextAnexo from '../../../../components/text-anexo';
import TextItem from '../../../../components/text-item';
import useFormatter from '../../../../hooks/useFormatter';
import useLoading from '../../../../hooks/useLoading';
import { fetchRepresentante, isEditableSelector, representanteSelector } from '../../../../store/empresa';
import { formatCpf } from '../../../../util/cpf';
import { openPopup } from '../../../../util/window';
import useModulo from '../../../../hooks/useModulo';
import { Alerta } from '../../../../constants';
import { useLocation } from "react-router";
import { useState } from "react";
import { representantesAlertaNivelSelector } from '../../../../store/empresa';
import TarefasDrawer from '../../licencas/_tarefasDrawer';

export default function EmpresaRepresentanteDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const representante = useSelector(representanteSelector);
  const { formatDate, formatDateTime, formatBoolean } = useFormatter();
  const loading = useLoading(fetchRepresentante.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const nivel = useSelector(representantesAlertaNivelSelector);
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
   const location = useLocation();
    const pathname = location.pathname;
    const origem = pathname.substring(pathname.indexOf("/empresas"));
    const modulo = pathname.split("/")[1];
    const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/representantes/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/representantes`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/representantes/${id}/`, `logs_/empresas/${empresaId}/representantes/${id}/`);
  };

  return (
    <Spin spinning={loading}>
      <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId}  onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="600px">
          <TextItem label={t('Sócio')}>{representante?.socio ? representante.socio.id + ' - ' + representante.socio.nome : ''}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          <TextItem label={t('Nome')}>{representante?.nome}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('CPF')}>{formatCpf(representante?.cpf)}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
       <Col flex="200px">
          <TextItem label={t('email')}>{representante?.email}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t('Registro na Receita Federal')}>{formatBoolean(representante?.receitaFederal)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Data Inicial')}>{formatDate(representante?.dataInicial)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Prazo Indeterminado')}>{formatBoolean(representante?.indeterminado)}</TextItem>
        </Col>
        <Col flex="200px">{representante?.indeterminado === false && <TextItem label={t('Data Final')}>{formatDate(representante?.dataFinal)}</TextItem>}</Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t('Registro na Junta Comercial')}>{formatBoolean(representante?.procuracaoRegistro)}</TextItem>
        </Col>
        <Col flex="200px">
          {representante?.procuracaoRegistro === true && <TextItem label={t('Data de Registro')}>{formatDate(representante?.procuracaoDataRegistro)}</TextItem>}
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t('Poderes')}>{representante?.poderes}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextAnexo label={t('Anexo')} value={representante?.anexo} />
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t('Observação')}>{representante?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(representante?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(representante?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{empresaId}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
